import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import PageHeader from '../components/PageHeader';

export default function MyProfile() {
  const { user, loginUser } = useAuth();
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    name:     user?.name     || '',
    email:    user?.email    || '',
    phone:    user?.phone    || '',
    location: user?.location || '',
    bio:      user?.bio      || '',
    skills:   user?.skills?.join(', ') || '',
  });

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true); setError(''); setSuccess('');
    try {
      const res = await fetch('http://localhost:5000/api/auth/update', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          ...form,
          skills: form.skills.split(',').map(s => s.trim()).filter(Boolean),
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      loginUser(localStorage.getItem('token'), data);
      setSuccess('Profile updated successfully!');
      setEditing(false);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageHeader title="My Profile" breadcrumb="My Profile" />
      <section className="section-pad">
        <div className="container" style={{ maxWidth: 800 }}>

          {error   && <div className="auth-alert error mb-4"><i className="fa fa-exclamation-circle me-2"></i>{error}</div>}
          {success && <div className="auth-alert success mb-4"><i className="fa fa-check-circle me-2"></i>{success}</div>}

          <div className="profile-card">
            {/* Avatar */}
            <div className="profile-avatar-section">
              <div className="profile-avatar">{user?.name?.charAt(0).toUpperCase()}</div>
              <div>
                <h4>{user?.name}</h4>
                <span className="profile-role-badge">{user?.role}</span>
                <p className="text-muted mt-1" style={{ fontSize: 14 }}>{user?.email}</p>
              </div>
              <button className="btn-grad ms-auto" onClick={() => setEditing(!editing)}>
                <i className={`fa ${editing ? 'fa-times' : 'fa-edit'} me-2`}></i>
                {editing ? 'Cancel' : 'Edit Profile'}
              </button>
            </div>

            {/* Form */}
            <form onSubmit={handleSave} className="profile-form">
              <div className="profile-form-grid">
                <div className="contact-field">
                  <label>Full Name</label>
                  <div className="contact-input-wrap">
                    <i className="fa fa-user"></i>
                    <input type="text" value={form.name} disabled={!editing}
                      onChange={e => setForm({ ...form, name: e.target.value })} />
                  </div>
                </div>
                <div className="contact-field">
                  <label>Email</label>
                  <div className="contact-input-wrap">
                    <i className="fa fa-envelope"></i>
                    <input type="email" value={form.email} disabled />
                  </div>
                </div>
                <div className="contact-field">
                  <label>Phone</label>
                  <div className="contact-input-wrap">
                    <i className="fa fa-phone"></i>
                    <input type="text" placeholder="+91 00000 00000" value={form.phone} disabled={!editing}
                      onChange={e => setForm({ ...form, phone: e.target.value })} />
                  </div>
                </div>
                <div className="contact-field">
                  <label>Location</label>
                  <div className="contact-input-wrap">
                    <i className="fa fa-map-marker-alt"></i>
                    <input type="text" placeholder="City, Country" value={form.location} disabled={!editing}
                      onChange={e => setForm({ ...form, location: e.target.value })} />
                  </div>
                </div>
              </div>

              <div className="contact-field mt-3">
                <label>Skills <span style={{ color: '#888', fontWeight: 400 }}>(comma separated)</span></label>
                <div className="contact-input-wrap">
                  <i className="fa fa-tools"></i>
                  <input type="text" placeholder="React, Node.js, MongoDB" value={form.skills} disabled={!editing}
                    onChange={e => setForm({ ...form, skills: e.target.value })} />
                </div>
              </div>

              <div className="contact-field mt-3">
                <label>Bio</label>
                <div className="contact-input-wrap textarea">
                  <i className="fa fa-align-left"></i>
                  <textarea rows="4" placeholder="Tell us about yourself..." value={form.bio} disabled={!editing}
                    onChange={e => setForm({ ...form, bio: e.target.value })}></textarea>
                </div>
              </div>

              {editing && (
                <button type="submit" className="contact-submit-btn mt-4" disabled={loading}>
                  {loading ? <><i className="fa fa-spinner fa-spin me-2"></i>Saving...</> : <><i className="fa fa-save me-2"></i>Save Changes</>}
                </button>
              )}
            </form>
          </div>
        </div>
      </section>
    </>
  );
}
